<template>
  <v-btn text>
    <div
      :class="{hamburger: true, 'hamburger--slider': true, 'is-active': menuIsOpen}"
      @click="toggleMenu"
    >
      <div class="hamburger-box">
        <div class="hamburger-inner"></div>
      </div>
      <span v-if="$vuetify.breakpoint.mdAndUp"> {{ $t('header.menu.label')}}</span>
    </div>
  </v-btn>
</template>

<script>
  export default {
    name: 'TheMenuToggle',

    data() {
      return {
        menuIsOpen: false,
      }
    },

    methods: {
      toggleMenu() {
        this.menuIsOpen = !this.menuIsOpen
        this.$emit('menuToggle', this.menuIsOpen)
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"

  $hamburger-layer-width: 13px
  $hamburger-layer-height: 2px
  $hamburger-layer-spacing: 3px
  $hamburger-layer-border-radius: 2px
  $hamburger-layer-color: $primary-color

  @import "../../../node_modules/hamburgers/_sass/hamburgers/hamburgers"

  .hamburger
    color: $primary-color

</style>
